import { createSlice } from '@reduxjs/toolkit';
import { AuthState } from '@/types/auth';
import { auth } from './thunks';

const initialState: AuthState = {
  user: null,
  token: localStorage.getItem('token'),
  isLoading: false,
  error: null,
  isAuthenticated: !!localStorage.getItem('token'),
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearError: state => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      // Login
      .addCase(auth.login.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(auth.login.fulfilled, state => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(auth.login.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // Token
      .addCase(auth.token.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(auth.token.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
        state.user = action.payload.user;
        state.token = action.payload.access_token;
        state.isAuthenticated = true;
      })
      .addCase(auth.token.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      // Logout
      .addCase(auth.logout.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(auth.logout.fulfilled, state => {
        state.isLoading = false;
        state.error = null;
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
      })
      .addCase(auth.logout.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = authSlice.actions;
export const authReducer = authSlice.reducer;
